import './lib/locale/i18n';
import '@fontsource/inter';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import router from './router/router';
import './index.css';
import { NotificationToastContainer } from './components/organisms/notification-toast';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<HelmetProvider>
			<RouterProvider
				router={router}
				future={{ v7_startTransition: true }}
			/>
			<NotificationToastContainer />
		</HelmetProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
